// src/contexts/AppProvider.tsx - Main app provider that combines all contexts
import React, { ReactNode } from 'react';
import { AuthProvider } from './AuthContext';
import { AdminProvider } from './AdminContext';
import { ThemeProvider } from './ThemeContext';
import { NavigationProvider } from './NavigationContext';
import { CustomerJourneyProvider } from './CustomerJourneyContext';

interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  return (
    <ThemeProvider>
      <NavigationProvider>
        <AuthProvider>
          <CustomerJourneyProvider>
            <AdminProvider>
              {children}
            </AdminProvider>
          </CustomerJourneyProvider>
        </AuthProvider>
      </NavigationProvider>
    </ThemeProvider>
  );
};
